/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{wrap as r}from"../../utils/wrap.js";import{isEasingArray as t}from"./is-easing-array.js";function i(i,o){return t(i)?i[r(0,i.length,o)]:i}export{i as getEasingForSegment};
//# sourceMappingURL=get-easing-for-segment.js.map
